/* ==========================================================
   ITEM OF THE WEEK (Monaco Inspired)
   Variant & Quantity Controller Script
========================================================== */

document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".vs-item-of-week");
    if (!section) return;

    const variantsJsonEl = document.getElementById("vs-iow-variants-json");
    if (!variantsJsonEl) return;

    let variants = [];
    try {
        variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
        console.error("Failed to parse variants JSON", e);
        return;
    }

    const form = section.querySelector("#vs-iow-form-element");
    const variantIdInput = section.querySelector("#vs-iow-variant-id");
    const swatches = section.querySelectorAll(".vs-iow-swatch");
    const sizeBtns = section.querySelectorAll(".vs-iow-size-btn");
    const selects = section.querySelectorAll(".vs-iow-select");

    const priceEl = section.querySelector("[data-price]");
    const comparePriceEl = section.querySelector("[data-compare-price]");
    const colorTextEl = section.querySelector(".vs-iow-selected-color");

    const btnAddToCart = section.querySelector(".vs-iow-add-to-cart");
    const btnBuyNow = section.querySelector("#vs-iow-buy-now-btn");

    const qtyInput = section.querySelector(".vs-iow-qty-input");
    const qtyMinus = section.querySelector(".vs-iow-qty-btn.minus");
    const qtyPlus = section.querySelector(".vs-iow-qty-btn.plus");

    // Option indexes selected values tracking
    // Pick active presets or first ones from DOM
    let selectedOptions = [];
    
    // Find initial state from active elements
    const initialGroups = section.querySelectorAll(".vs-iow-option-group");
    initialGroups.forEach((group) => {
        // Key off data-option-index, not the loop counter: single-value options
        // are not rendered, so position in the DOM no longer tracks option order.
        const index = parseInt(group.getAttribute("data-option-index"), 10);
        if (isNaN(index)) return;

        const activeSwatch = group.querySelector(".vs-iow-swatch.active");
        const activeSize = group.querySelector(".vs-iow-size-btn.active");
        const select = group.querySelector(".vs-iow-select");

        if (activeSwatch) {
            selectedOptions[index] = activeSwatch.getAttribute("data-value");
        } else if (activeSize) {
            selectedOptions[index] = activeSize.getAttribute("data-value");
        } else if (select) {
            selectedOptions[index] = select.value;
        }
    });

    const getSelectedVariant = () => {
        return variants.find(v => {
            let match = true;
            if (v.option1 !== null && selectedOptions[0] !== undefined) match = match && (v.option1 === selectedOptions[0]);
            if (v.option2 !== null && selectedOptions[1] !== undefined) match = match && (v.option2 === selectedOptions[1]);
            if (v.option3 !== null && selectedOptions[2] !== undefined) match = match && (v.option3 === selectedOptions[2]);
            return match;
        }) || variants[0];
    };

    const formatMoney = (cents) => {
        let currencySymbol = "Rs. ";
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
            if (window.Shopify.currency.active === "INR") {
                currencySymbol = "Rs. ";
            } else if (window.Shopify.currency.active === "USD") {
                currencySymbol = "$";
            } else {
                currencySymbol = window.Shopify.currency.active + " ";
            }
        }
        return currencySymbol + Math.round(cents / 100).toLocaleString('en-IN');
    };

    const updateVariantStatus = () => {
        const variant = getSelectedVariant();
        if (!variant) return;

        // Update variant ID input
        if (variantIdInput) variantIdInput.value = variant.id;

        // Update price display
        if (priceEl) {
            priceEl.innerText = formatMoney(variant.price);
        }

        if (comparePriceEl) {
            if (variant.compare_at_price > variant.price) {
                comparePriceEl.innerText = formatMoney(variant.compare_at_price);
                comparePriceEl.style.display = "inline";
            } else {
                comparePriceEl.style.display = "none";
            }
        }

        // Availability is communicated by the buttons alone — no stock label
        if (btnAddToCart) {
            btnAddToCart.disabled = !variant.available;
            btnAddToCart.innerText = variant.available ? "ADD TO CART" : "SOLD OUT";
        }
        if (btnBuyNow) {
            btnBuyNow.disabled = !variant.available;
            btnBuyNow.innerText = variant.available ? "BUY IT NOW" : "SOLD OUT";
        }
    };

    // Color Swatches Clicks
    swatches.forEach(swatch => {
        swatch.addEventListener("click", () => {
            const group = swatch.closest(".vs-iow-option-group");
            group.querySelectorAll(".vs-iow-swatch").forEach(s => s.classList.remove("active"));
            swatch.classList.add("active");

            const val = swatch.getAttribute("data-value");
            const idx = parseInt(group.getAttribute("data-option-index"));
            selectedOptions[idx] = val;

            if (colorTextEl) colorTextEl.innerText = val;
            updateVariantStatus();
        });
    });

    // Size Buttons Clicks
    sizeBtns.forEach(btn => {
        btn.addEventListener("click", () => {
            const group = btn.closest(".vs-iow-option-group");
            group.querySelectorAll(".vs-iow-size-btn").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");

            const val = btn.getAttribute("data-value");
            const idx = parseInt(group.getAttribute("data-option-index"));
            selectedOptions[idx] = val;

            updateVariantStatus();
        });
    });

    // Dropdown Select options
    selects.forEach(select => {
        select.addEventListener("change", () => {
            const idx = parseInt(select.getAttribute("data-option-index"));
            selectedOptions[idx] = select.value;
            updateVariantStatus();
        });
    });

    // Quantity selectors
    qtyMinus?.addEventListener("click", () => {
        let current = parseInt(qtyInput.value) || 1;
        if (current > 1) qtyInput.value = current - 1;
    });

    qtyPlus?.addEventListener("click", () => {
        let current = parseInt(qtyInput.value) || 1;
        qtyInput.value = current + 1;
    });

    // Buy It Now direct redirect
    btnBuyNow?.addEventListener("click", (e) => {
        e.preventDefault();
        const variant = getSelectedVariant();
        if (!variant || !variant.available) return;
        const qty = parseInt(qtyInput.value) || 1;
        window.location.href = `/cart/${variant.id}:${qty}`;
    });

    // Initialize initial state values
    updateVariantStatus();
});
